const STORAGE_PATH = {
  NEWSPAPER: 'newspaper/',
  STORE: 'store/',
  REWARD: 'reward/'
}
export { STORAGE_PATH }
export default STORAGE_PATH
